<template>
  <div class="flex justify-center my-2 mx-auto">
    <b-button
      :to="'/events-manager/applicant-profile/' + params.booking_id"
      icon-pack="feather"
      icon="icon-eye"
      variant="warning"
      class="shadow-lg btn-back-to-top"
      @click="updateApplicationViewedStatus"
    >
      View More Info
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue"

export default {
  name: "CellRendererProfile",
  props: {
    params: Object,
  },
  components: {
    BButton,
  },
  created() {},
  methods: {
    async updateApplicationViewedStatus() {
      const apiRequestContent = {
        id: this.params.booking_id,
        view_status: true,
      }

      try {
        const response = await this.$http.put("/api/application-view-status", {
          data: apiRequestContent,
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
